import React, { Component } from "react";
import Ink from "react-ink";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import { getAssetUrl } from "../../../../helpers/getAssetUrl";
import CustomizationV3 from "../../CustomizationV3";
import "./style.css";

class RecommendedItemsV2 extends Component {
  forceStateUpdate = () => {
    setTimeout(() => {
      this.forceUpdate();
      this.props.update();
    }, 100);
  };

  addProductToCart = (product) => {
    const { addProduct } = this.props;
    addProduct(product);
    this.forceStateUpdate();
  };

  render() {
    const {
      product,
      restaurant,
      cartProducts,
      addProduct,
      removeProduct,
    } = this.props;

    const isItemExistInCart = (id) => {
      return cartProducts.find((item) => item.id === id);
    };

    const cartItem = cartProducts.find((cp) => cp.id === product.id);

    return (
      <div className="recommended-card">

        {/* IMAGE */}
        <Link to={restaurant.slug + "/" + product.id}>
          <LazyLoad>
            <img
              src={
                product.image
                  ? getAssetUrl(product.image)
                  : "/assets/img/various/green_placeholder.png"
              }
              alt={product.name}
              className="recommended-img"
            />
          </LazyLoad>
        </Link>

        {/* CONTENT */}
        <div className="recommended-body">

          {/* PRODUCT NAME */}
          <h4 className="recommended-title">
            {product.name}
          </h4>

          {/* RATING */}
          <div className="recommended-rating">
            ⭐ 4.8 <span>Delivery</span>
          </div>

          {/* ADD BUTTON */}
          <div className="recommended-action">

            {product.is_active ? (
              product.addons && Object.keys(product.addons).length ? (
                <CustomizationV3
                  product={product}
                  addProduct={this.addProductToCart}
                  cartProducts={cartProducts}
                  forceUpdate={this.forceStateUpdate}
                  updateCart={this.props.updateCart}
                />
              ) : isItemExistInCart(product.id) ? (
                <div className="qty-controller">

                  <button
                    className="qty-btn"
                    onClick={() => {
                      removeProduct(product);
                      this.forceStateUpdate();
                    }}
                  >
                    -
                  </button>

                  <span className="qty-text">
                    {cartItem.quantity}
                  </span>

                  <button
                    className="qty-btn"
                    onClick={() => {
                      addProduct(product);
                      this.forceStateUpdate();
                    }}
                  >
                    +
                  </button>

                </div>
              ) : (
                <button
                  className="add-btn"
                  onClick={() => {
                    product.quantity = 1;
                    addProduct(product);
                    this.forceStateUpdate();
                  }}
                >
                  Add to order
                  <Ink duration="500" />
                </button>
              )
            ) : (
              <span className="itemNotAvail">
                {localStorage.getItem("cartItemNotAvailable")}
              </span>
            )}

          </div>
        </div>
      </div>
    );
  }
}

export default RecommendedItemsV2;
